module.exports = __webpack_public_path__ + "img/서브2_패스킥슛.adc2ac0a.svg";